import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const OOPS_M1_StructureAndPhasesOfCompilerDesign = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
  <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Structure and Phases of Compiler Design"
    videos={[
      "https://www.youtube.com/embed/VTFOHSc4Wso",
      "https://www.youtube.com/embed/aJuBDfBWiVc",
      "https://www.youtube.com/embed/Dd3DWRpqI40",
    ]}
    takeaways={[
      { text: "Practice one example from this topic (almost similar procedure for every other question)" },
      { text: "Most probable question in both CAT1 and FAT" },
      { text: "Learn the symbol table also (it is an add on question like for 3 marks)" },
    ]}
    questions={[
      "Look at the following instruction: total_marks=60% of internal_marks + 40% of external marks. Feed the above instruction as input in the way that your compiler understands and show the result of transformation of your input in each stage of the compiler and find the target assembly-level code from it",
      "Explain the various phases of the compiler and show the output of each phase of the compilation for the given expression a=(b*c)+(c-d)/f",
      'a) Explain the phases of a compiler for the given expression "if (x > 5) { y =x +2; } else { y = x - 2; }." Provide a brief description of each phase and its role in the compilation process.',
      "Draw the structure of a compiler and describe various phases in the compilation process. Mention the output of the following statement: id1=id2*id3/5.",
      'What are the various phases of a compiler? Explain each phase in detail by using the input "a=(b+c)*(b+c)*2"',
      "Show the output of each compiler phase for the following source program. Assume c is an integer and d is a float type of variable. Use BRGE (Branch greater than or equal to) and goto mnemonics wherever it is required. If(x>=y) { x=c*d; }",
    ]}
    exampleVideos={[]}
  />
);
}

export default OOPS_M1_StructureAndPhasesOfCompilerDesign;
